<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-xl-3">
                        <!-- <b-alert show dismissible class="mb-3">Property MN7xx is not receiving hits. Either your site is
                                not receiving any sessions.</b-alert> -->
                        <div class="card">
                            <div class="card-body">
                                <i class="fa fa-info-circle text-muted float-right" v-b-tooltip.hover title="More Info"></i>
                                <h4 class="m-0 font-16">тарифный план</h4>
                                <h2 class="my-3 text-center" id="active-users-count">Базовый</h2>
                                <p class="text-muted m-0">
                                    перейти на PRO
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-9">
                        <div class="card">
                            <div class="card-body">
                                <div class="text-center">
                                    <div class="row">
                                        <div class="col-md-6 col-xl-3">
                                            <div class="py-1">
                                                <i class="fe-tag font-24"></i>
                                                <h3>{{ tunnelsCount }}</h3>
                                                <p class="text-uppercase mb-1 font-13 font-weight-medium">
                                                    Всего туннелей
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xl-3">
                                            <div class="py-1">
                                                <i class="fe-archive font-24"></i>
                                                <h3 class="text-warning">120МБ/512МБ</h3>
                                                <p class="text-uppercase mb-1 font-13 font-weight-medium">
                                                    Использовано трафика
                                                </p>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-xl-6">
                                            <div class="py-1">
                                                <i class="fe-delete font-24"></i>
                                                <h3 class="text-danger">30 минут</h3>
                                                <p class="text-uppercase mb-1 font-13 font-weight-medium">
                                                    Макс. продолжительность сессии
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                
                <div class="row">
                    <!-- end col -->
                    <div class="col-xl-12 col-lg-8">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="header-title mb-3">Использование трафика</h4>
                                <div class="row align-items-center">
                                    <div class="col-xl-12">
                                        <apexchart class="apex-charts" height="380" type="area" :series="series"
                                            :options="stackedAreaChart.chartOptions"></apexchart>
                                    </div>
                                    <!-- end col -->

                                </div>
                                <!-- end row -->
                            </div>
                            <!-- end card-body-->
                        </div>
                        <!-- end card-->
                    </div>
                    <!-- end col-->
                </div>
            </div>
        </div>

        <!-- end row -->
        <!-- 
        <div class="row">
     
            <div class="col-xl-5">
                <b-overlay id="overlay-background" :show="projectsAreLoading" variant="white" opacity="0.85" rounded="sm">
                    <div class="card-box">
                        <div class="float-right">
                            <button class="btn btn-light" style="margin-top:-10px;" v-b-modal.new_target_modal>
                                <i class="mdi mdi-plus-circle mr-1"></i>
                                {{ $t('new_target') }}
                            </button>
                        </div>
                        <h4 class="header-title mb-3">{{ $t('targets') }}</h4>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="inbox-widget slimscroll" v-slimscroll style="max-height: 400px;">
                                    <div class="inbox-item" :key="index" v-for="(target, index) in targets"
                                        style="line-height: 40px;">
                                        <router-link :to="{
                                            name: 'target_overview',
                                            params: { hash: target.hash }
                                        }">
                                            <div class="inbox-item-img">
                                                <img src="https://www.gravatar.com/avatar/3b3be63a4c2a439b013787725dfce802?d=identicon"
                                                    class="rounded-circle" alt />
                                            </div>
                                            <p class="inbox-item-author">{{ target.value }}</p>

                                            <p class="inbox-item-date">
                                                <span class="badge badge-light-info lead">{{ target.status }}</span>
                                            </p>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                       
                        </div>
                    </div>
                </b-overlay>
              
            </div>

             <div class="col-xl-7">
                <div class="card-box">
                    <div class="dropdown float-right">
                        <a href="#" class="dropdown-toggle arrow-none card-drop" data-toggle="dropdown"
                            aria-expanded="false"></a>
                    </div>
                    <h4 class="header-title mb-3">{{ $t('recent_events') }}</h4>
                    <div class="row">
                        <div class="col-md-12">...</div>
                    </div>
                </div>
            
            </div> 
           
        </div> -->

    </div>
</template>
  
<script>
import Portlet from "@src/components/Portlet.vue";
import simplebar from 'simplebar-vue';
import axios from 'axios';
import { humanFileSize } from "@src/utils"

const revenuePieChart = {
    series: [],
    chartOptions: {
        pie: {
            expandOnClick: false
        },
        colors: ['#dcdcdc', '#3bafda', '#333333', '#00b19d'],
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false,
        },
        tooltip: {
            x: {
                labels: false,
                show: false
            },
            y: {
                title: {
                    formatter: (seriesName) => {
                        return '';
                    }
                }
            },
        },
        grid: {
            show: false,
            padding: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            }
        },
    },
};

const stackedAreaChart = {
    chartOptions: {
        chart: {
            stacked: true,
            events: {
                selection(chart, e) {
                    console.log(new Date(e.xaxis.min));
                }
            },
        },
        colors: ['#4fc6e1', '#1abc9c', '#dee2e6'],
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: [2],
            curve: 'smooth'
        },
        fill: {
            type: 'gradient',
            gradient: {
                opacityFrom: 0.6,
                opacityTo: 0.8,
            }
        },
        legend: {
            position: 'top',
            horizontalAlign: 'left'
        },
        xaxis: {
            type: 'datetime'
        },
        yaxis: {
            labels: {
                formatter: function (value) {
                    return humanFileSize(value);
                }
            },
        },
    },

};
import apexchart from 'vue-apexcharts'
export default {
    components: { Portlet, simplebar, apexchart },
    data() {
        return {
            tunnels: [],
            tunnel: {},
            tunnel_stat: [],
            stackedAreaChart: stackedAreaChart,
            revenuePieChart: revenuePieChart,
            series: [],



            target: "",
            projectInfo: {},
            targets: [],
            datacollection: null,
            projectsAreLoading: false,
            descState: null,

        };
    },
    computed: {
        selectedTunnel() {
            return Object.keys(this.tunnel).length != 0
        },
        targetState() {
            return this.target.length > 0 ? true : false;
        },
        tunnelsCount() {
            return this.tunnels.length;
        }
    },
    beforeMount() {
        // this.loadProjectInfo();
    },
    mounted() {
        this.loadTunnels();
        this.loadTunnelStat()
    },
    watch: {
        tunnel: {
            handler(val, oldVal) {

            },
        }
    },

    methods: {
        loadTunnels() {
            let that = this;
            this.projectsAreLoading = true;
            axios
                .get(`/api/secure/wh/tunnels/list/`)
                .then(response => {
                    this.projectsAreLoading = false;
                    const data = response.data;
                    if (data.error) {
                        throw data.error;
                    }
                    that.tunnels = data.data;
                })
                .catch(e => {
                    throw new Error(e);
                });
        },
        selectTunnel(hash) {
            for (let t of this.tunnels) {
                if (t.hash == hash) {
                    this.tunnel = t
                    break
                }
            }
        },

        loadTunnelStat() {
            let that = this;
            axios
                .get(`/api/secure/wh/tunnels/graph/`)
                .then(response => {
                    const data = response.data;
                    if (data.error) {
                        throw data.error;
                    }
                    let series = []
                    let tunnels = {}
                    for (let r of data.data) {
                        if (series.some(s => s.hash === r.hash)) {
                            for (let sid in series) {
                                if (series[sid].hash == r.hash) {
                                    series[sid].data.push([r.date, r.used])
                                    break
                                }
                            }
                        } else {
                            series.push({ hash: r.hash, name: r.name, data: [[r.date, r.used]] })
                        }

                        // if (tunnels.hasOwnProperty(r.hash)) {
                        //     tunnels[r.hash]
                        // } else {
                        //     tunnels[r.hash] = [[r.date, r.used]];
                        // }
                    }
                    // for (let ok of Object.keys(tunnels)) {
                    //     series.push({ name: tunnels[ok], data: tunnels[ok] })
                    // }
                    console.log('tunnels=', tunnels)
                    that.series = series
                    console.log('series:', that.series)


                })
                .catch(e => {
                    throw new Error(e);
                });
        },


        handleOK(evt) {
            evt.preventDefault();
            this.handleAddTarget();
        },
        handleAddTarget() {
            if (!this.checkFormValidity()) {
                return;
            }
            this.addNewTarget();
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity();
            return valid;
        },

        // addNewTarget() {
        //     let that = this;
        //     client()
        //         .post(`/api/secure/project/${this.$route.params.hash}/targets/`, {
        //             target: this.target
        //         })
        //         .then(response => {
        //             const data = response.data;
        //             if (data.error) {
        //                 throw data.error;
        //             }
        //             // that.loadProjectInfo();
        //             that.$bvModal.hide("new_target_modal");
        //         })
        //         .catch(e => {
        //             throw new Error(e);
        //         });
        // },
        getRandomInt() {
            return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
        },
        loadProjectInfo() {
            let that = this;
            this.projectsAreLoading = true;
            // client()
            //     .get(`/api/secure/project/${this.$route.params.hash}/info/`)
            //     .then(response => {
            //         this.projectsAreLoading = false;
            //         const data = response.data;
            //         if (data.error) {
            //             throw data.error;
            //         }
            //         that.projectInfo = data.data;
            //         if (
            //             that.projectInfo.status == "verification" ||
            //             that.projectInfo.status == "settings"
            //         ) {
            //             that.$root.$options.appStore.dispatch("pushSubMenuItems", []);
            //             that.$router.replace({
            //                 name: "projects_new_hash",
            //                 params: { hash: that.$route.params.hash }
            //             });
            //         }


            //     })
            //     .catch(e => {
            //         throw new Error(e);
            //     });
        }
    }
};
</script>
<style>
.selectedItem {
    background: #f1f5f7;
}
</style>